<div class="w-100">
  <div class="header-modal mb-0">
    <div class="main-title mt-0 mb-0 w-100">
      <h3>Assign Facilities To {{this.name}}</h3>
    </div>

    <span class="close-dialog" mat-dialog-close>
      <i class="material-icons">close</i>
    </span>
  </div>

  <form *ngIf="formGroup" [formGroup]="formGroup">
    <div class="info-banner">
      <i class="material-icons info-icon">info</i>
      <span>Choose the specialist you're assigning facilities from.</span>
    </div>

    <div class="form-grid">
      <div class="input-wrap input-mat-select">
        <label>{{isSpecialist ? 'Specialist Name' : 'Clinical Reviewer Name'}}</label>
        <app-portal-select
          id="specialist-name"
          formControlName="specialist"
          [items]="specialists"
          [withFilter]="true"
          [clearable]="true"
          placeholder="Specialist name"
          itemName="name"
          (selectionChange)="specialistChange($event)">
          <ng-template let-item #option>
            {{item?.name}}
          </ng-template>
        </app-portal-select>
      </div>
      <div class="assignments-close-check">
        <div class="facility-content-title facility-content-title--dba">
          <mat-checkbox  formControlName="closeAssignments">
            Close Open Assignment Of {{this.name}}
          </mat-checkbox>
        </div>
      </div>
             <div class="form-group input-wrap end-date-input">
          <label>End Date</label>
          <mat-datepicker #pickerDate></mat-datepicker>
          <mat-datepicker-toggle [for]="pickerDate" matSuffix></mat-datepicker-toggle>
          <input  [matDatepicker]="pickerDate" [min]="minDateToAssign"
                  formControlName="enddate"
                  matInput
                  type="datetime" placeholder="MM/DD/YYYY">
        </div>
      <div class="form-group input-wrap start-date-input">
        <label>Start Date</label>
        <mat-datepicker #pickerDate1></mat-datepicker>
        <mat-datepicker-toggle [for]="pickerDate1" matSuffix></mat-datepicker-toggle>
        <input  [matDatepicker]="pickerDate1" [min]="minDateToAssign"
                formControlName="startdate"
                matInput
                type="datetime" placeholder="MM/DD/YYYY">
      </div>
  </div>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="title">
              <h5>Assign facilites manually</h5>
              <hr>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-grid">
        <div class="form-group input-wrap input-mat-select">
          <label>{{'Facilities'}}</label>
          <app-portal-select
            id="facilities"
            formControlName="facilities"
            [items]="facilities"
            [withFilter]="true"
            [multiple]="true"
            [clearable]="true"
            [required] = "true"
            placeholder="Facilities"
            itemId="id"
            itemName="name"
            (selectionChange)="facilitiesChange($event)">
            >
            <ng-template let-item #option>
              {{item?.id}} {{item?.name}}
            </ng-template>
          </app-portal-select>
        </div>
        <div class="form-group  input-wrap label-wrap note reassign-textfield-box">
          <label for="textField">Add Facilities or Paste<span class="required-symbol">*</span></label>
          <textarea
            class="multi-reassign-textfield"
            id="textField"
            placeholder="Add Facilities by Id"
            [formControl]="formGroup.get('textField')"
            (input)="onTextareaValueChanged($event)">
        </textarea>
        </div>
        </div>
      </mat-expansion-panel>
  </form>



  <div class="footer-modal">
    <cmp-button [class]="'cancel mr-20'" mat-dialog-close text="Cancel"></cmp-button>
    <app-spinner-button *ngIf="formGroup" (spinClick)="assignSpecialist($event)" text="Assign"></app-spinner-button>
  </div>
</div>

